module.exports = __webpack_public_path__ + "3f65138980d555eaffb24fea50b3f2ac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-9.png
// module id = 2651
// module chunks = 0